import { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { cmsContentWrapperId } from "@nxplatform/helpers/helpers";
import { getIsMobile } from "@nxplatform/helpers/helpers-pure";
import { webViewStatus } from "./query.hook.js";
const textPageClass = "is-text-page";
const useTextPageFlagHook = ({
  isTextPage,
  clearIsTextPageFlag
}) => {
  const [baseLocation, _] = useState(window.location.pathname);
  const { pathname } = useLocation();
  const isMobile = getIsMobile();
  const isWebView = webViewStatus();
  const cmsPageContent = document.getElementById(cmsContentWrapperId);
  useEffect(() => {
    if (isTextPage && pathname !== baseLocation) {
      clearIsTextPageFlag();
      if (cmsPageContent) {
        cmsPageContent.remove();
      }
    }
  }, [pathname]);
  useEffect(() => {
    const { classList } = document.body;
    isTextPage ? classList.add(textPageClass) : classList.remove(textPageClass);
    return () => classList.remove(textPageClass);
  }, [isTextPage]);
  useEffect(() => {
    if (isTextPage && isMobile && isWebView) {
      const linksList = document.querySelectorAll("a");
      for (let i = 0, l = linksList.length; i < l; i++) {
        const link = linksList[i];
        if (link.href !== "#") {
          link.href = `${link.href}?webView=true`;
        }
      }
    }
  }, [isTextPage, isMobile, isWebView]);
};
export {
  textPageClass,
  useTextPageFlagHook
};
